import React, { createContext, useContext, useState } from 'react';

const TrackContext = createContext(null);

export function TrackProvider({ children }) {
  const [track, setTrack] = useState('all');
  return (
    <TrackContext.Provider value={{ track, setTrack }}>
      {children}
    </TrackContext.Provider>
  );
}

export function useTrack() {
  const ctx = useContext(TrackContext);
  return ctx || { track: 'all', setTrack: (_) => {} };
}
